import React from 'react'
import styled from 'styled-components'
import { Box, Button, Card, Flex, Stamp, Text } from 'pcln-design-system'
import HotelSearchActions from '../../../actions/HotelSearchActions'
import constants from '../../promos/express-promo/constants'
import PricebreakersPromo1 from './PricebreakersPromo1'
import PricebreakersPromo2 from './PricebreakersPromo2'
import PricebreakersPromo3 from './PricebreakersPromo3'

const StyledButton = styled(Button)`
  ${props => props.theme.mediaQueries[0]} {
    height: 65px;
    width: 224px;
  }
  ${props => props.theme.mediaQueries[3]} {
    height: 48px;
  }
  font-size: 16px;
  height: 48px;
  margin-left: auto;
  line-height: 22px;
  padding: 0px;
  width: 204px;
`

const FlexWrapper = styled(Flex)`
  flex-direction: column;
  ${props => props.theme.mediaQueries[0]} {
    flex: 1 1 50%
  }
  ${props => props.theme.mediaQueries[3]} {
    flex: 1 1 66%
  }
`

const Wrapper = styled(Card)`
  ${props => props.theme.mediaQueries[0]} {
    height: 340px;
  }
  ${props => props.theme.mediaQueries[3]} {
    height: 250px;
  }
  background-color: white;
  border-radius: 4px;
`

const TiltStamp = styled(Stamp)`
  position: absolute;
  transform: translate(-14px, -8px) rotate(-28deg);
`

type InfoGraphicProps = {
  children: object
  contentText: string
}

type PricebreakersPromoProps = {
  isMobile?: boolean
  handleModalOpen?: () => void
}

const InfoGraphic = ({ children, contentText }: InfoGraphicProps) => {
  return (
    <Flex flexDirection={['row', 'column']} width={[1, 1/2]} mt={[3, 0]}>
      <Box height={['56px', '92px']} mx={['none', 'auto']} textAlign='center' width={['56px', '96px']}>
        {children}
      </Box>
      <Text color='text' fontWeight={[600, 400]} ml={['11px', 'auto']} mb={['auto' , 0]} mt={['auto', 3]} textAlign={['left', 'center']}>
        {contentText}
      </Text>
    </Flex>
  )
}

const handleDesktopDealButtonClick = () => HotelSearchActions.toggleCollectionsForm(true)
const handleMobileDealButtonClick = (handleModalOpen: () => void) => () => handleModalOpen()
const SearchButton = ({ handleClick }: { handleClick: () => void }) => (
  <StyledButton
    aria-label='Collections Promo Button'
    color='background'
    onClick={handleClick}
  >
    <Text color='primary' fontWeight='bold'>
      Search Pricebreakers
    </Text>
  </StyledButton>
)

export default function PricebreakersPromo ({ isMobile = false, handleModalOpen} : PricebreakersPromoProps) {
  const width = isMobile ? '56' : '99'
  const height = isMobile ? '56' : '92'
  return (
    <Wrapper boxShadowSize='md' mt={[4, 0]} width={[1, 2/3]}>
      <Flex
        flexDirection={['column', 'row']}
        style={{ height: '100%' }}
      >
        <TiltStamp color='text.lightest' bg='warning'>New</TiltStamp>
        <FlexWrapper p={3}>
          <Flex justifyContent='space-between'>
            <Text color='text' fontSize={[3, 5]} fontWeight='bold'>
              Introducing
              <Text.span color='primary'> Pricebreakers</Text.span>
            </Text>
            {!isMobile && <SearchButton handleClick={handleDesktopDealButtonClick} />}
          </Flex>
          <Flex style={{ minHeight: '150px' }}>
            <Flex flexDirection={['column', 'row']} mt={[0, 4, 3]} mb={[2, 0]}>
              <InfoGraphic contentText={constants.collections.promoIcon1.content}>
                <PricebreakersPromo1 width={width} height={height} />
              </InfoGraphic>
              <InfoGraphic contentText={constants.collections.promoIcon2.content}>
                <PricebreakersPromo2 width={width} height={height}/>
              </InfoGraphic>
              <InfoGraphic contentText={constants.collections.promoIcon3.content}>
                <PricebreakersPromo3 width={width} height={height}/>
              </InfoGraphic>
            </Flex>
          </Flex>
          {isMobile && (
            <SearchButton handleClick={handleMobileDealButtonClick(handleModalOpen)} />
          )}
        </FlexWrapper>
      </Flex>
    </Wrapper>
  )
}
